import { Component } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { ButtonModule } from 'primeng/button';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Component({
    selector: 'app-unauthorized-page',
    templateUrl: './unauthorized-page.component.html',
    styleUrls: ['./unauthorized-page.component.scss'],
    standalone: true,
    imports: [ButtonModule],
})
export class UnauthorizedPageComponent {
    constructor(
        private auth0: AuthService,
        private router: Router
    ) {}

    goToDashboard(): void {
        this.router.navigate(['']);
    }

    async logout(): Promise<void> {
        const url = `${environment.auth0.logoutUrl}?client_id=${environment.auth0.clientId}&returnTo=${encodeURI(
            environment.auth0.logoutReturnUrl
        )}`;

        await this.auth0.logout({
            openUrl(_url: string) {
                window.location.replace(url);
            },
        });
    }
}
